import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { PageHeader, Card } from "../components/Card";
import { VoiceConsole } from "../components/VoiceConsole";
import { DataTable } from "../components/DataTable";

export default function VoicePage() {
  const { t } = useI18n();
  const [metrics, setMetrics] = useState([]);
  useEffect(() => {
    const load = () => api.get("/voice/metrics").then((r) => setMetrics(r.data));
    load();
    const h = setInterval(load, 15000);
    return () => clearInterval(h);
  }, []);
  const cols = [
    { key: "language", label: t("language"), render: (r) => <span className="font-mono text-xs uppercase">{r.language}</span> },
    { key: "stage", label: t("stage"), render: (r) => <span className="font-mono text-xs">{r.stage}</span> },
    { key: "avg_ms", label: t("avgMs"), render: (r) => <span className="font-semibold">{r.avg_ms}</span> },
    { key: "count", label: t("count") },
    { key: "failures", label: t("failures") },
  ];
  return (
    <div>
      <PageHeader title={t("voiceTitle")} sub={t("voiceSub")} />
      <div className="grid gap-6 lg:grid-cols-5">
        <Card className="lg:col-span-3"><VoiceConsole /></Card>
        <div className="lg:col-span-2">
          <h2 className="mb-3 text-base font-semibold text-slate-900">{t("latency")}</h2>
          <DataTable cols={cols} rows={metrics.map((m) => ({ ...m, id: `${m.language}-${m.stage}` }))} testId="voice-metrics-table" />
        </div>
      </div>
    </div>
  );
}
